/**
 * Register all used Forge Icons in this file in order to get icons to render
 * throughout the platform.
 *
 * Importing the desired icon(s) and defining them
 * within the Forge icon registry should be done as early in your application
 * bootstrapping process as possible. Make sure all icons are defined, prior
 * to the page rendering or else the component will not be able to find the
 * icon data when it is instantiated.
 */
import {
  tylIconAccount,
  tylIconAccountBalance,
  tylIconAccountCheck,
  tylIconAccountCircle,
  tylIconAccountGroup,
  tylIconAdd,
  tylIconAddAlert,
  tylIconAddCircle,
  tylIconAddCircleOutline,
  tylIconAlert,
  tylIconAlertCircleOutline,
  tylIconAlertDecagram,
  tylIconAlertOutline,
  tylIconApi,
  tylIconArrangeBringForward,
  tylIconArrowBack,
  tylIconArrowDownward,
  tylIconArrowUpward,
  tylIconAttachFile,
  tylIconBarChart,
  tylIconBusiness,
  tylIconCalendar,
  tylIconCalendarClock,
  tylIconCalendarTextOutline,
  tylIconCampaign,
  tylIconCardPlus,
  tylIconChartBar,
  tylIconChartBox,
  tylIconChartCombo,
  tylIconChartHistogram,
  tylIconChartLine,
  tylIconChartScatterPlot,
  tylIconChartTimelineVariant,
  tylIconChartTimelineVariantShimmer,
  tylIconCheck,
  tylIconCheckCircle,
  tylIconCheckCircleOutline,
  tylIconCheckDecagram,
  tylIconCheckboxMarkedCircleOutline,
  tylIconCheckboxMarkedOutline,
  tylIconChevronDoubleDown,
  tylIconChevronDoubleUp,
  tylIconChevronDown,
  tylIconChevronLeft,
  tylIconChevronRight,
  tylIconChevronUp,
  tylIconCircleEditOutline,
  tylIconClear,
  tylIconClockOutline,
  tylIconClose,
  tylIconCloseCircle,
  tylIconCode,
  tylIconCog,
  tylIconCompareHorizontal,
  tylIconContentCopy,
  tylIconContentPaste,
  tylIconCrop,
  tylIconCursorMove,
  tylIconDangerous,
  tylIconDatabase,
  tylIconDatabaseArrowRight,
  tylIconDatabaseCog,
  tylIconDatabaseEdit,
  tylIconDatabaseFilter,
  tylIconDatabasePlus,
  tylIconDelete,
  tylIconDockBottom,
  tylIconDomain,
  tylIconDotsVertical,
  tylIconDownload,
  tylIconDragHandle,
  tylIconDragHorizontal,
  tylIconDragIndicator,
  tylIconEast,
  tylIconEdit,
  tylIconError,
  tylIconExpandMore,
  tylIconEye,
  tylIconEyeOff,
  tylIconFace,
  tylIconFileChart,
  tylIconFileDocument,
  tylIconFileDocumentEdit,
  tylIconFileMultipleOutline,
  tylIconFileOutline,
  tylIconFileSearchOutline,
  tylIconFileTableBox,
  tylIconFileTree,
  tylIconFilter,
  tylIconFilterAlt,
  tylIconFilterList,
  tylIconFilterListAlt,
  tylIconFilterMenu,
  tylIconFilterPlus,
  tylIconFilterVariant,
  tylIconFilterVariantCheck,
  tylIconFilterVariantRemove,
  tylIconFormatAlignCenter,
  tylIconFormatAlignLeft,
  tylIconFormatAlignRight,
  tylIconFormatBold,
  tylIconFormatItalic,
  tylIconFormatPaint,
  tylIconFormatText,
  tylIconFunction,
  tylIconFunctions,
  tylIconGroup,
  tylIconGroups,
  tylIconHeadQuestionOutline,
  tylIconHelpCircleOutline,
  tylIconHelpOutline,
  tylIconHistory,
  tylIconHowToReg,
  tylIconInfo,
  tylIconInfoOutline,
  tylIconInsertPhoto,
  tylIconInsights,
  tylIconKeyboardArrowDown,
  tylIconKeyboardArrowLeft,
  tylIconKeyboardArrowRight,
  tylIconKeyboardArrowUp,
  tylIconLayers,
  tylIconLinkVariant,
  tylIconListAlt,
  tylIconLock,
  tylIconLockAlert,
  tylIconLockOpen,
  tylIconLogout,
  tylIconMailOutline,
  tylIconMap,
  tylIconMapMarker,
  tylIconMapMarkerOutline,
  tylIconMenu,
  tylIconMenuBook,
  tylIconMoreVert,
  tylIconNewspaperVariantOutline,
  tylIconNorth,
  tylIconNotes,
  tylIconNotifications,
  tylIconNotificationsActive,
  tylIconNotificationsOff,
  tylIconOfficeBuilding,
  tylIconOndemandVideo,
  tylIconOpenInBrowser,
  tylIconOpenInNew,
  tylIconPeople,
  tylIconPercent,
  tylIconPerson,
  tylIconPieChart,
  tylIconPlayArrow,
  tylIconPlaylistEdit,
  tylIconPound,
  tylIconPrint,
  tylIconPublic,
  tylIconRedo,
  tylIconRefresh,
  tylIconRemoveCircle,
  tylIconRemoveCircleOutline,
  tylIconReplay,
  tylIconSave,
  tylIconSchedule,
  tylIconSchool,
  tylIconSearch,
  tylIconSetAll,
  tylIconSetCenter,
  tylIconSetCenterRight,
  tylIconSetLeftCenter,
  tylIconSetNone,
  tylIconSettings,
  tylIconShareVariant,
  tylIconShieldAlertOutline,
  tylIconShieldCheckOutline,
  tylIconShieldOffOutline,
  tylIconShieldRemoveOutline,
  tylIconShieldSyncOutline,
  tylIconShowChart,
  tylIconSort,
  tylIconSortAlt,
  tylIconSortAlphabeticalAscending,
  tylIconSortAlphabeticalDescending,
  tylIconSortAlphabeticalDescendingVariant,
  tylIconSortAscending,
  tylIconSortDescending,
  tylIconSouth,
  tylIconSparkles,
  tylIconSwapHoriz,
  tylIconSwapVert,
  tylIconTable,
  tylIconTableLarge,
  tylIconTextFields,
  tylIconThumbDownAlt,
  tylIconThumbDownOffAlt,
  tylIconThumbUpAlt,
  tylIconThumbUpOffAlt,
  tylIconTooltipEdit,
  tylIconTransitConnection,
  tylIconTransitConnectionHorizontal,
  tylIconTranslate,
  tylIconTrashCan,
  tylIconTrashCanOutline,
  tylIconTylerTalkingTLogo,
  tylIconUndo,
  tylIconUpdate,
  tylIconVariable,
  tylIconVideoLibrary,
  tylIconViewColumn,
  tylIconViewColumnOutline,
  tylIconVisibilityOff,
  tylIconVolumeHigh,
  tylIconVolumeMute,
  tylIconWarning,
  tylIconWizardHat,
  tylIconGroupAlt,
} from '@tylertech/tyler-icons';
import { IconRegistry } from '@tylertech/forge';

IconRegistry.define([
  tylIconAccount,
  tylIconAccountBalance,
  tylIconAccountCheck,
  tylIconAccountCircle,
  tylIconAccountGroup,
  tylIconAdd,
  tylIconAddAlert,
  tylIconAddCircle,
  tylIconAddCircleOutline,
  tylIconAlert,
  tylIconAlertCircleOutline,
  tylIconAlertDecagram,
  tylIconAlertOutline,
  tylIconApi,
  tylIconArrangeBringForward,
  tylIconArrowBack,
  tylIconArrowDownward,
  tylIconArrowUpward,
  tylIconAttachFile,
  tylIconBarChart,
  tylIconBusiness,
  tylIconCalendar,
  tylIconCalendarClock,
  tylIconCalendarTextOutline,
  tylIconCampaign,
  tylIconCardPlus,
  tylIconChartBar,
  tylIconChartBox,
  tylIconChartCombo,
  tylIconChartHistogram,
  tylIconChartLine,
  tylIconChartScatterPlot,
  tylIconChartTimelineVariant,
  tylIconChartTimelineVariantShimmer,
  tylIconCheck,
  tylIconCheckCircle,
  tylIconCheckCircleOutline,
  tylIconCheckDecagram,
  tylIconCheckboxMarkedCircleOutline,
  tylIconCheckboxMarkedOutline,
  tylIconChevronDoubleDown,
  tylIconChevronDoubleUp,
  tylIconChevronDown,
  tylIconChevronLeft,
  tylIconChevronRight,
  tylIconChevronUp,
  tylIconCircleEditOutline,
  tylIconClear,
  tylIconClockOutline,
  tylIconClose,
  tylIconCloseCircle,
  tylIconCode,
  tylIconCog,
  tylIconCompareHorizontal,
  tylIconContentCopy,
  tylIconContentPaste,
  tylIconCrop,
  tylIconCursorMove,
  tylIconDangerous,
  tylIconDatabase,
  tylIconDatabaseArrowRight,
  tylIconDatabaseCog,
  tylIconDatabaseEdit,
  tylIconDatabaseFilter,
  tylIconDatabasePlus,
  tylIconDelete,
  tylIconDockBottom,
  tylIconDomain,
  tylIconDotsVertical,
  tylIconDownload,
  tylIconDragHandle,
  tylIconDragHorizontal,
  tylIconDragIndicator,
  tylIconEast,
  tylIconEdit,
  tylIconError,
  tylIconExpandMore,
  tylIconEye,
  tylIconEyeOff,
  tylIconFace,
  tylIconFileChart,
  tylIconFileDocument,
  tylIconFileDocumentEdit,
  tylIconFileMultipleOutline,
  tylIconFileOutline,
  tylIconFileSearchOutline,
  tylIconFileTableBox,
  tylIconFileTree,
  tylIconFilter,
  tylIconFilterAlt,
  tylIconFilterList,
  tylIconFilterListAlt,
  tylIconFilterMenu,
  tylIconFilterPlus,
  tylIconFilterVariant,
  tylIconFilterVariantCheck,
  tylIconFilterVariantRemove,
  tylIconFormatAlignCenter,
  tylIconFormatAlignLeft,
  tylIconFormatAlignRight,
  tylIconFormatBold,
  tylIconFormatItalic,
  tylIconFormatPaint,
  tylIconFormatText,
  tylIconFunction,
  tylIconFunctions,
  tylIconGroup,
  tylIconGroupAlt,
  tylIconGroups,
  tylIconHeadQuestionOutline,
  tylIconHelpCircleOutline,
  tylIconHelpOutline,
  tylIconHistory,
  tylIconHowToReg,
  tylIconInfo,
  tylIconInfoOutline,
  tylIconInsertPhoto,
  tylIconInsights,
  tylIconKeyboardArrowDown,
  tylIconKeyboardArrowLeft,
  tylIconKeyboardArrowRight,
  tylIconKeyboardArrowUp,
  tylIconLayers,
  tylIconLinkVariant,
  tylIconListAlt,
  tylIconLock,
  tylIconLockAlert,
  tylIconLockOpen,
  tylIconLogout,
  tylIconMailOutline,
  tylIconMap,
  tylIconMapMarker,
  tylIconMapMarkerOutline,
  tylIconMenu,
  tylIconMenuBook,
  tylIconMoreVert,
  tylIconNewspaperVariantOutline,
  tylIconNorth,
  tylIconNotes,
  tylIconNotifications,
  tylIconNotificationsActive,
  tylIconNotificationsOff,
  tylIconOfficeBuilding,
  tylIconOndemandVideo,
  tylIconOpenInBrowser,
  tylIconOpenInNew,
  tylIconPeople,
  tylIconPercent,
  tylIconPerson,
  tylIconPieChart,
  tylIconPlayArrow,
  tylIconPlaylistEdit,
  tylIconPound,
  tylIconPrint,
  tylIconPublic,
  tylIconRedo,
  tylIconRefresh,
  tylIconRemoveCircle,
  tylIconRemoveCircleOutline,
  tylIconReplay,
  tylIconSave,
  tylIconSchedule,
  tylIconSchool,
  tylIconSearch,
  tylIconSetAll,
  tylIconSetCenter,
  tylIconSetCenterRight,
  tylIconSetLeftCenter,
  tylIconSetNone,
  tylIconSettings,
  tylIconShareVariant,
  tylIconShieldAlertOutline,
  tylIconShieldCheckOutline,
  tylIconShieldOffOutline,
  tylIconShieldRemoveOutline,
  tylIconShieldSyncOutline,
  tylIconShowChart,
  tylIconSort,
  tylIconSortAlt,
  tylIconSortAlphabeticalAscending,
  tylIconSortAlphabeticalDescending,
  tylIconSortAlphabeticalDescendingVariant,
  tylIconSortAscending,
  tylIconSortDescending,
  tylIconSouth,
  tylIconSparkles,
  tylIconSwapHoriz,
  tylIconSwapVert,
  tylIconTable,
  tylIconTableLarge,
  tylIconTextFields,
  tylIconThumbDownAlt,
  tylIconThumbDownOffAlt,
  tylIconThumbUpAlt,
  tylIconThumbUpOffAlt,
  tylIconTooltipEdit,
  tylIconTransitConnection,
  tylIconTransitConnectionHorizontal,
  tylIconTranslate,
  tylIconTrashCan,
  tylIconTrashCanOutline,
  tylIconTylerTalkingTLogo,
  tylIconUndo,
  tylIconUpdate,
  tylIconVariable,
  tylIconVideoLibrary,
  tylIconViewColumn,
  tylIconViewColumnOutline,
  tylIconVisibilityOff,
  tylIconVolumeHigh,
  tylIconVolumeMute,
  tylIconWarning,
  tylIconWizardHat,
]);
